export default (props, vars) => () =>
  window.open(vars?.['defaultbox145']?.['item']?.['action'], '_blank').focus();
